import script from "./successful-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./successful-modal.vue?vue&type=script&setup=true&lang=js"

import "./successful-modal.vue?vue&type=style&index=0&id=c39f17c2&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c39f17c2"]])

export default __exports__